"use client";

import { ToastContainer } from "react-toastify";
import BlankLayout from "../layouts/blank/BlankLayout";
import "react-toastify/dist/ReactToastify.css";
import { SessionProvider } from "next-auth/react";
import { Bounce } from "react-toastify";
import { ThemeWrapper } from "../components/ThemeWrapper";

export default function AuthLayout({
	children,
}: {
	children: React.ReactNode;
}) {
	return (
		<SessionProvider>
			<ThemeWrapper>
				<BlankLayout>
					{children}
					<ToastContainer
						position="top-right"
						autoClose={10000}
						hideProgressBar={false}
						newestOnTop={false}
						closeOnClick={false}
						rtl={false}
						pauseOnFocusLoss
						draggable
						pauseOnHover
						theme="light"
						transition={Bounce}
					/>
				</BlankLayout>
			</ThemeWrapper>
		</SessionProvider>
	);
}
